import { useAuth } from "@/context/AuthContext";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import { Loader2 } from "lucide-react";

export default function AdminPage() {
  const { user, loading } = useAuth();

  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[var(--bg)]">
        <Loader2 className="animate-spin text-[var(--gold)]" size={28} />
      </div>
    );
  }
  return user ? <AdminDashboard /> : <AdminLogin />;
}
